export function name() {
    return "Georgios Valotasios";
}
export function createTitle(title) {
    return title || name();
}
